// src/components/Management.js
import React, { useState } from "react";
import Cateringordersdetails from "./Cateringordersdetails";
import CateringPackages from "./CateringPackages";
import Vendordersdetails from "./Vendordersdetails";
import { Link } from "react-router-dom";
function Cateringorders() {
    const [activeView, setActiveView] = useState("user");

    // Style constants
    const activeColor = "#b15cd6";
    const inactiveColor = "#f0f2f5";
    const activeTextColor = "#ffffff";
    const inactiveTextColor = "#333333";
    const activeBorderColor = "#b15cd6";
    const inactiveBorderColor = "#ced4da";

    const commonButtonStyles = {
        padding: "0.5rem 0.5rem",
        borderRadius: "0.375rem",
        fontWeight: 600,
        borderWidth: "1px",
        borderStyle: "solid",
        cursor: "pointer",
        transition:
            "background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, color 0.15s ease-in-out",
        outline: "none",
        boxShadow: "none",
    };

    // Original margin for the container-fluid, potentially for a global page header or spacing.
    const pageWrapperMarginTopString = "35px";

    // `topOffset` from original code: "Height of the top part of this component (e.g., if there's a global navbar)"
    // This is interpreted as the total desired offset from the viewport top to where
    // the actual content block (button bar + scrollable area) should begin.
    const contentEffectiveStartOffsetString = "80px"; // Using the original `topOffset` value

    // Calculate the necessary margin for the main flex container (inside col-lg-10)
    // to achieve the contentEffectiveStartOffset, considering pageWrapperMarginTop.
    // e.g. if content should start at 80px from viewport top, and page wrapper already provides 35px,
    // then the internal margin needed for the content block is 80 - 35 = 45px.
    const internalMarginTopValue =
        parseFloat(contentEffectiveStartOffsetString) - parseFloat(pageWrapperMarginTopString);
    const internalMarginTop = `${internalMarginTopValue}px`; // e.g., "45px"

    // The height for the main flex container (which holds the button bar and scrollable content).
    // It should fill the remaining viewport height after accounting for contentEffectiveStartOffset.
    const mainFlexContainerHeight = `calc(100vh - ${contentEffectiveStartOffsetString})`;

    // The original `marginTop: "110px"` on the flex parent and `marginTop: "-30px"`
    // on the scrollable content are now replaced by this more structured layout approach.
    // The `buttonBarHeight` variable from the original code is an estimation and not directly
    // needed for this flexbox and sticky positioning layout.


    return (
        <div className="container-fluid p-0" style={{ marginTop: '85px' }}>
            <div className="row">
                <div className="col-lg-2"></div> {/* Sidebar or empty space */}
                <div className="col-lg-8 col-md-12 col-sm-12 col-12">

                    <p
                        className="breadcrumb maamaas-home-bredcum or7"
                        style={{
                            position: "fixed",
                            top: "64px",
                            left: "1vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            padding: "5px 0",
                            fontSize: "18px",
                            fontWeight: "bold",
                            textAlign: "center",
                            margin: 0,
                            height: "33px",
                            zIndex: "9999",
                        }}
                    >
                        <Link
                            to="/Homes"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Home
                        </Link>

                        <span className="separator"> &gt; </span>
                        <span style={{ color: "purple", fontWeight: "bold" }}>
                            <Link

                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Order_Management
                            </Link>
                        </span>  <span className="separator"> &gt; </span>
                        <span style={{ color: "purple", fontWeight: "bold" }}>
                            <Link

                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Catering & Services
                            </Link>
                        </span>
                    </p>
                    <div
                        style={{
                            marginTop: "10px",
                            height: "550px",
                            overflowY: "auto",
                            overflowX: "hidden",  // vertical scroll if needed
                            // overflowIW: "hidden", // prevent horizontal scroll completely
                            whiteSpace: "nowrap",  // optional: prevent text from wrapping and causing horizontal scroll
                            scrollbarWidth: "none",     // ✅ hides scrollbar in Firefox
                            msOverflowStyle: "none",    // ✅ hides scrollbar in IE/Edge
                        }}

                    >
                        {/* Button Bar Container */}
                        <div
                            className="d-flex justify-content-center row g-2" // Bootstrap class for centering buttons
                            style={{
                                // padding: "1rem 0", // Adds vertical spacing around the buttons
                                backgroundColor: "#ffffff", // Crucial for sticky; content won't show through
                                flexShrink: 0, // Prevents this bar from shrinking if content is sparse
                                position: "sticky",
                                top: 0, // Sticks to the top of its parent (the Main Flex Container)
                                zIndex: 10, // Ensures it stays above scrolling content
                                gap: "10px",
                                // borderBottom: '1px solid #e0e0e0', // Optional: if a visual separator is desired
                            }}
                        >

                            <button
                                type="button"
                                className="me-2 btn" // Bootstrap margin utility for spacing between buttons
                                style={{
                                    fontSize: "13px !important",
                                    width: "140px", // Fixed width for consistency
                                    ...commonButtonStyles,
                                    backgroundColor: activeView === "user" ? activeColor : inactiveColor,
                                    color: activeView === "user" ? activeTextColor : inactiveTextColor,
                                    borderColor: activeView === "user" ? activeBorderColor : inactiveBorderColor,
                                }}
                                onClick={() => setActiveView("user")}
                            >
                                Orders
                            </button>
                            <button
                                className="btn"
                                type="button"
                                style={{
                                    fontSize: "13px !important",
                                    width: "140px", // Fixed width for consistency
                                    ...commonButtonStyles,
                                    backgroundColor: activeView === "vendor" ? activeColor : inactiveColor,
                                    color: activeView === "vendor" ? activeTextColor : inactiveTextColor,
                                    borderColor: activeView === "vendor" ? activeBorderColor : inactiveBorderColor,
                                }}
                                onClick={() => setActiveView("vendor")}
                            >
                                Reports
                            </button>
                            <button
                                className="btn"
                                type="button"
                                style={{
                                    fontSize: "13px !important",
                                    width: "140px", // Fixed width for consistency
                                    ...commonButtonStyles,
                                    backgroundColor: activeView === "delivery" ? activeColor : inactiveColor,
                                    color: activeView === "delivery" ? activeTextColor : inactiveTextColor,
                                    borderColor: activeView === "delivery" ? activeBorderColor : inactiveBorderColor,
                                }}
                                onClick={() => setActiveView("delivery")}
                            >
                                Package Orders
                            </button>

                        </div>

                        {/* Scrollable Content Area */}
                        <div
                            style={{
                                flexGrow: 1,
                            }}
                        >
                            {activeView === "user" && <Cateringordersdetails />}
                            {activeView === "vendor" && <CateringPackages />}
                            {activeView === "delivery" && <Vendordersdetails />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Cateringorders;